import SHA256 from "crypto-js/sha256";

const hashString = (value: string): string => SHA256(value).toString().slice(0, 12);

export const STORAGE_VERSION = 1;

export const LOCAL_STORAGE_KEYS = Object.freeze({
  appRoot: hashString("aiChatApp"),
  dailyMessageCount: hashString("dailyMessageCount"),
  lastResetDate: hashString("lastResetDate"),
  totalMessageCount: hashString("totalMessageCount"),
  lastAdMessageCount: hashString("lastAdMessageCount"),
  rateLimitPrefix: hashString("rateLimit"),
  rateLimitSignin: hashString("signin"),
  rateLimitSignup: hashString("signup"),
  creditsRemaining: hashString("creditsRemaining"),
  dailyCreditsRemaining: hashString("dailyCreditsRemaining"),
  dailyCreditsResetAt: hashString("dailyCreditsResetAt"),

});

export const STORAGE_FIELD_KEYS = Object.freeze({
  app: hashString("app"),
  auth: hashString("auth"),
  chats: hashString("chats"),
  attempts: hashString("attempts"),
  lastAttempt: hashString("lastAttempt"),
  blockedUntil: hashString("blockedUntil"),
  dailyMessageCount: hashString("dailyMessageCount"),
  totalMessageCount: hashString("totalMessageCount"),
  lastMessageDate: hashString("lastMessageDate"),
  activeSessionId: hashString("activeSessionId"),
  sessions: hashString("sessions"),
});

export const LEGACY_STORAGE_KEYS = Object.freeze({
  appRoot: "aiChatApp",
  dailyMessageCount: "dailyMessageCount",
  lastResetDate: "lastResetDate",
  totalMessageCount: "totalMessageCount",
  rateLimitPrefix: "rateLimit_",

});
